import { defineMessages } from 'react-intl';

export default defineMessages({
  emailLabel: {
    id: 'accountSignin.forgotPassword.emailLabel',
    defaultMessage: 'Email',
    description: 'Label for email input.',
  },
  returnToSigninText: {
    id: 'accountSignin.returnToSigninText',
    defaultMessage: 'Return to sign in',
    description: 'Button text on password reset success page',
  },
});
